import React from "react";

import Loader from "../../../common/components/Loader";
import StatisticBox, { StatisticsBoxProps } from "../../../common/components/StatisticBox";
import AttendeeFilters, { AttendeeFiltersProps } from "../../../components/Events/AttendeeFilters";

interface EventAttendeesSidebarProps extends AttendeeFiltersProps {
  isLoadingData: boolean;
  isLoadingFilters: boolean;
  totalAttendees: number;
}

const EventAttendeesSidebar: React.FC<EventAttendeesSidebarProps> = (props) => {

  const data: StatisticsBoxProps = {
    title: "Total Attendees",
    description: "",
    value: props.isLoadingData ? "..." : props.totalAttendees,
  };

  return (
    <>
      <div className="m-3">
        <div className="position-relative">
          <StatisticBox {...data} />
          <Loader show={props.isLoadingData} />
        </div>
      </div>
      <div className="m-3">
        <div className="position-relative">
          <AttendeeFilters {...props} />
          <Loader show={props.isLoadingFilters} />
        </div>
      </div>
    </>
  );
};

export default EventAttendeesSidebar;
